export default __webpack_public_path__ + "static/media/Prior-Intimation-of-Board-Meeting.d612c155.pdf";